import { render, staticRenderFns } from "./CardioEcostressList.vue?vue&type=template&id=24f9e57d"
import script from "./CardioEcostressList.vue?vue&type=script&lang=js"
export * from "./CardioEcostressList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports